









import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VAspectRatioBox extends Vue {
  @Prop({ default: 4 }) width!: number;
  @Prop({ default: 3 }) height!: number;

  get ratio(): number {
    if (!this.width) return 0;
    return (this.height / this.width) * 100;
  }
}
